// src/converters/championship.ts
import { Championship } from '@/model';
import {
  GetChampionshipItemResponse,
  GetChampionshipResponse,
  PostChampionshipResponse,
  GetChampionshipByIdResponse,
  PutChampionshipResponse,
} from '@/services/response/championship';

export class ChampionshipConverter {
  static toDomainFromGetItemResponse(response: GetChampionshipItemResponse): Championship {
    return {
      uuid: response.uuid,
      name: response.name,
      is_filtered: response.is_filtered,
      is_active: response.is_active,
      created_at: response.created_at,
      updated_at: response.updated_at,
      // seasons: [] // se no futuro o GET de lista trouxer seasons, mapeia aqui
    };
  }

  static toDomainFromPaginatedResponse(response: GetChampionshipResponse): Championship[] {
    return response.data.map(ChampionshipConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostChampionshipResponse): Championship {
    return {
      uuid: response.uuid,
      name: response.name,
      is_filtered: response.is_filtered,
      is_active: response.is_active,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetChampionshipByIdResponse): Championship {
    return {
      uuid: response.uuid,
      name: response.name,
      is_filtered: response.is_filtered,
      is_active: response.is_active,
      created_at: response.created_at,
      updated_at: response.updated_at,
      // seasons: response.seasons ? SeasonConverter... (quando existir no contrato)
    };
  }

  static toDomainFromPutResponse(response: PutChampionshipResponse): Championship {
    return {
      uuid: response.uuid,
      name: response.name,
      is_filtered: response.is_filtered,
      is_active: response.is_active,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
